/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.entities.detail.availability.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.service.calendar',
  'acme.common.service.userPreferences'
])

.controller('EntitiesDetailAvailabilityController', ['$scope', '$state', '$filter', 'ApiService', 'HelpersService', 'PermissionsService', 'CalendarService', 'UserPreferencesService', function($scope, $state, $filter, ApiService, HelpersService, PermissionsService, CalendarService, UserPreferencesService) {

    $scope.entitiesDetailAvailability = {

      model: {},
      dateRangeState: {
        available: [],
        unavailable: []
      },

      init: function() {
        this.getTemplates();
      },

      getAvailability: function() {
        ApiService.resource.availability.detail({ entityId: $state.params.id }).then(this.success.getAvailability, this.error.getAvailability);
      },

      getTemplates: function() {
        ApiService.resource.templates($.extend({}, { resourceCategory: HelpersService.cap($state.params.type) }, HelpersService.getPaginator())).then(this.success.getTemplates, this.error.getTemplates);
      },

      findResourceTemplate: function(id) {
        var i, ii,
          r = false;
        for (i = 0, ii = this.resourceTemplates.length; i < ii; i++) {
          if (this.resourceTemplates[i].id === id) {
            r = {
              index: i,
              resourceTemplate: this.resourceTemplates[i]
            };
            break;
          }
        }
        return r;
      },

      process: function() {

        if (this.model.hasOwnProperty('available')) {
          this.processAvail('available');
        }

        if (this.model.hasOwnProperty('unavailable')) {
          this.processAvail('unavailable');
        }

      },

      createRepeatDays: function() {
        return {
          Su: false,
          M: false,
          Tu: false,
          W: false,
          Th: false,
          F: false,
          Sa: false
        };
      },

      processAvail: function(type) {
        var i, ii,
          j, jj,
          endDate,
          startDate,
          endTime,
          startTime,
          d = new Date(),
          item,
          processResourceTemplate,
          resourceTemplates = [];

        processResourceTemplate = function(resourceTemplateId) {
          var self = $scope.entitiesDetailAvailability,
            found = self.findResourceTemplate(resourceTemplateId);
          if (found) {
            resourceTemplates.push(self.resourceTemplates[found.index]);
          }
        };

        for (i=0,ii=this.model[type].length;i<ii;i++) {

          // Reset templates between items
          resourceTemplates = [];

          item = this.model[type][i];
          item.repeatDays = this.createRepeatDays();

          for (j=0,jj=item.weekdays.length;j<jj;j++) {
            if (item.repeatDays.hasOwnProperty(item.weekdays[j])) {
              item.repeatDays[item.weekdays[j]] = true;
            }
          }

          endDate = CalendarService.toISO8601(item.endDate);
          startDate = CalendarService.toISO8601(item.startDate);

          endTime = CalendarService.timeToString(item.endTime, UserPreferencesService.dateFormats['hourFormat']);
          startTime = CalendarService.timeToString(item.startTime, UserPreferencesService.dateFormats['hourFormat']);

          item.displayEndDate = $filter('date')(endDate, UserPreferencesService.getDateFormat('shortDate', 'dateFormat'));
          item.displayStartDate = $filter('date')(startDate, UserPreferencesService.getDateFormat('shortDate', 'dateFormat'));

          item.endTime.date = endTime;
          item.startTime.date = startTime;

          this.dateRangeState[type].push({ showEndDate: (CalendarService.parseDate(endDate).getTime() > CalendarService.parseDate(startDate).getTime()) });

          if (item.resourceTemplateIds instanceof Array) {
            item.resourceTemplateIds.forEach(processResourceTemplate);
            item.resourceTemplates = angular.copy(resourceTemplates);
          }

        }

      },

      success: {
        getAvailability: function(response) {
          var self = $scope.entitiesDetailAvailability;

          if (response.data.payload) {
            self.model = response.data.payload;
            self.process();
          }
        },

        getTemplates: function(response) {
          var self = $scope.entitiesDetailAvailability;

          self.resourceTemplates = response.data.payload.list;
          self.getAvailability();
        }
      },

      error: {
        getAvailability: function(response) {},
        getTemplates: function(response) {
          $scope.entitiesDetailAvailability.getAvailability();
        }
      }

    };

    $scope.entitiesDetailAvailability.init();

}]);